module.exports = __webpack_public_path__ + "img/kankou_7.27accdbc.jpg";